import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { isClaimDetailOpen } from "Order/Modules/Claim/Atom/claimDetailOpen";
import { CreateClaimForm } from "Order/Modules/Claim/Components/Form/CreateClaimForm";
import AddCircle from "@mui/icons-material/AddCircle";
import Close from "@mui/icons-material/Close";
import { Fab, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import { useState } from "react";

const tabsResource = Resources.base.claim.claimsTabs;

export const AddNewClaim = ({ orderId }: { orderId: number }) => {
	const { t } = useResource();
	const [_, setIsClaimOpen] = useAtom(isClaimDetailOpen);
	const [isFormOpen, setIsFormOpen] = useState(false);
	const iconColor = useTheme().palette.primary.main;

	return (
		<Paper
			sx={{
				borderRadius: 0,
				display: "flex",
				flexDirection: "column",
				flexGrow: 1,
				placeItems: !isFormOpen ? "center" : "flex-start center",
			}}
		>
			{!isFormOpen && (
				<>
					<Stack alignSelf="flex-end">
						<Fab
							size="small"
							onClick={() => {
								setIsFormOpen(false);
								setIsClaimOpen(false);
							}}
						>
							<Close />
						</Fab>
					</Stack>

					<Stack
						spacing={3}
						flexGrow={1}
						justifyContent="center"
						alignItems="center"
						sx={{ cursor: "pointer" }}
						onClick={() => {
							setIsFormOpen(true);
						}}
					>
						<Typography variant="h1">{t(tabsResource.addNew)}</Typography>
						<AddCircle fontSize="large" sx={{ color: iconColor }} />
					</Stack>
				</>
			)}
			{isFormOpen && (
				<Stack spacing={2}>
					<Fab
						size="small"
						onClick={() => {
							setIsFormOpen(false);
							setIsClaimOpen(false);
						}}
						sx={{ alignSelf: "flex-end" }}
					>
						<Close />
					</Fab>
					<CreateClaimForm orderId={orderId} />
				</Stack>
			)}
		</Paper>
	);
};
